<template>
  <footer>
    <div class="container-xxl">

      <div class="row boredered-footer-row justify-content-between justify-content-md-center justify-content-lg-between align-items-center">
        <div class="col-12 col-md-6 col-lg-4 text-center mb-3 mb-lg-0">
          <div class="social-media-wrapper">
            <div>
              <p class="footer-item">{{ t('landing-v2.footer.follow') }} <a href="#" class="footer-item">@Mimente.com</a></p>
            </div>

            <div class="social-media-wrapper__icons">
              <a href="https://www.facebook.com/profile.php?id=100094342175443&mibextid=ZbWKwL" class="me-3" target="_blank" rel="noreferrer noopener">
                <img :src="facebookIcon" alt="Facebook MiMente">
              </a>

              <a href="https://instagram.com/mimente.com?igshid=NzZhOTFlYzFmZQ==" class="me-3" target="_blank" rel="noreferrer noopener">
                <img :src="instagramIcon" alt="Instagram MiMente">
              </a>

              <a href="https://www.tiktok.com/@mimente.com" class="me-3" target="_blank" rel="noreferrer noopener">
                <img :src="tikTokIcon" alt="Tiktok MiMente">
              </a>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-8 col-lg-4 text-center mb-3 mb-lg-0">
          <router-link class="footer-item" :to="{name: 'terms-and-conditions'}">{{ t('landing-v2.footer.terms-and-conditions') }}</router-link>
          <span class="px-2">|</span>
          <router-link class="footer-item" :to="{name: 'privacy-notice'}">{{ t('landing-v2.footer.privacy-policy') }}</router-link>
        </div>

        <div class="col-12 col-md-12 col-lg-4 text-center">
          <p class="footer-item m-0">{{ t('landing-v2.footer.rights-reserved1') }} <br class="d-sm-none d-lg-block d-xl-none"> {{ t('landing-v2.footer.rights-reserved2') }}</p>
        </div>
      </div>

    </div>
  </footer>
</template>

<script>
import {useI18n} from 'vue-i18n'
import {useRouter} from "vue-router";
import {ref} from "vue";

export default {
  props: {
    facebookIcon: {
      default: require("@/assets/images/landingv2/facebook-icon.svg")
    },
    instagramIcon: {
      default: require("@/assets/images/landingv2/instagram-icon.svg")
    },
    tikTokIcon: {
      default: require("@/assets/images/landingv2/tiktok-icon.svg")
    }
  },
  setup(props) {
    const {t} = useI18n()
    const router = useRouter()

    const goToLanding = () => {
      const element = document.getElementById('hero-section');
      element.scrollIntoView({behavior: 'smooth', block: 'start'});
    }

    return {
      t,
      goToLanding
    }
  }
}
</script>

<style scoped>

footer {
  display: block;
  position: relative;
  width: 100%;
  /*background-color: var(--mm-main-background);*/
  color: white !important;
  font-family: var(--mm-font-gt-america-mono);
  text-transform: uppercase;
}

.boredered-footer-row {
  /*border-top: 1px solid var(--mm-primary);*/
  padding: 25px 0;
}

.footer__logo {
  height: 20px;
  width: auto;
}

.footer-item {
  font-size: 14px;
  text-decoration: none;
  color: white;
}

.social-media-wrapper {
  display: grid;
  grid-template-rows: repeat(2, auto);
  grid-template-columns: 1fr;
  gap: 5px;
}

.social-media-wrapper p {
  margin: 0;
}

.social-media-wrapper__icons a {
  display: inline-flex;
  align-items: center;
}

.social-media-wrapper__icons img {
  display: inline-block;
  height: 18px;
  width: auto;
}

/* Media Queries */
@media (min-width: 576px) {
  .social-media-wrapper {
    grid-template-rows: 1fr;
    grid-template-columns: repeat(2, auto);
    align-items: center;
    justify-content: space-evenly;
  }
}

@media (min-width: 768px) {
}

@media (min-width: 992px) {
}

@media (min-width: 1200px) {
}

@media (min-width: 1400px) {
}
</style>
